import { Link } from 'react-router-dom';
import Seo from '@/components/feature/Seo';
import { pageSeo } from '@/mocks/seo';

export default function PrivacyPolicy() {
  return (
    <main className="w-full py-12 md:py-16 bg-white">
      <Seo {...pageSeo.privacy} />
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-4xl mx-auto">
        <h1 className="text-2xl md:text-3xl font-bold text-navy-900 mb-8">Privacy Policy</h1>
        <div className="text-sm text-navy-700 leading-relaxed space-y-6">
          <p>
            At Leavitt Peak Press, we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you use our website and services.
          </p>
          <h2 className="text-lg font-semibold text-navy-900">1. Information We Collect</h2>
          <p>
            We may collect personal information including your name, email address, phone number, and mailing address when you fill out contact forms, submit manuscripts, or subscribe to our newsletter. We also collect non-personal information such as browser type, IP address, and pages visited.
          </p>
          <h2 className="text-lg font-semibold text-navy-900">2. How We Use Your Information</h2>
          <p>
            We use your information to provide our publishing services, respond to your inquiries, send newsletters and updates, improve our website, and comply with legal obligations. We do not sell your personal information to third parties.
          </p>
          <h2 className="text-lg font-semibold text-navy-900">3. Data Security</h2>
          <p>
            We implement appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.
          </p>
          <h2 className="text-lg font-semibold text-navy-900">4. Cookies</h2>
          <p>
            Our website may use cookies to enhance your browsing experience. You can choose to disable cookies in your browser settings, but this may affect certain functionality of our website.
          </p>
          <h2 className="text-lg font-semibold text-navy-900">5. Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites.
          </p>
          <h2 className="text-lg font-semibold text-navy-900">6. Your Rights</h2>
          <p>
            You have the right to access, correct, or delete your personal information. To exercise these rights, please <Link to="/contact-us" className="text-navy-500 hover:underline">contact us</Link>.
          </p>
          <h2 className="text-lg font-semibold text-navy-900">7. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page.
          </p>
          <p>
            If you have any questions about this Privacy Policy, please <Link to="/contact-us" className="text-navy-500 hover:underline">contact us</Link>.
          </p>
        </div>
      </div>
    </main>
  );
}